// Generic, pure helpers for manipulating multi-value filter params in a URLSearchParams.
// Page-specific concerns (e.g. resetting `page` to 1 on change) are layered on by the caller
// on the returned params — these stay side-effect free and never mutate the input.

/** Returns a new URLSearchParams with one value removed from a (possibly multi-value) key. */
export function removeFilterValue(
  params: URLSearchParams,
  key: string,
  value: string,
): URLSearchParams {
  const remaining = params.getAll(key).filter((v) => v !== value);
  const next = new URLSearchParams(params);
  next.delete(key);
  remaining.forEach((v) => next.append(key, v));
  return next;
}

/** Returns a new URLSearchParams with all the given filter keys removed (others untouched). */
export function clearFilterValues(
  params: URLSearchParams,
  keys: string[],
): URLSearchParams {
  const next = new URLSearchParams(params);
  keys.forEach((key) => next.delete(key));
  return next;
}
